import React from "react";
import { array, string, bool } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./row2rightcolumn.m.css";

const Row2RightColumn = ({ stories, bannerImg, bannerClick, show13Story }) => {
  const row2FirstVideoStories = stories.slice(0, 1);
  const row2SecondStories = stories.slice(1, 2);
  return (
    <div styleName="right_box">
      {row2FirstVideoStories.length > 0 && <NewsWithImage story={row2FirstVideoStories[0].story} />}
      <div>
        {show13Story && row2SecondStories.length > 0 && <LeftImageRightNews story={row2SecondStories[0].story} />}
      </div>
      <div styleName={`epaper_ad ${bannerClick && bannerImg ? "" : "background_epaper_background_color"}`}>
        {bannerClick && bannerImg ? (
          <a
            aria-label="epaper banner"
            target="_blank"
            rel="noreferrer"
            styleName="epaper_ad_wrapper"
            href={bannerClick}
          >
            <div styleName="image_wrapper">
              <img src={bannerImg} alt="banner" />
            </div>
          </a>
        ) : (
          <a
            target="_blank"
            rel="noreferrer"
            styleName="epaper_ad_wrapper_with2row"
            href="https://epaper.prothomalo.com/home.php?ref=ine1"
          >
            <div styleName="text_wrapper">ছাপা কাগজের মতো পড়ুন আজকের পত্রিকা</div>
            <div styleName="image_wrapper_with2row">
              <img
                styleName="epaper-image"
                src="https://images.prothomalo.com/prothomalo-bangla/2021-12/8f22f0c6-f808-40df-9676-52771474d05e/epaper_img.jpg"
                alt="banner"
              />
            </div>
          </a>
        )}
      </div>
    </div>
  );
};

Row2RightColumn.propTypes = {
  stories: array.isRequired,
  bannerClick: string,
  bannerImg: string,
  show13Story: bool,
};

export default Row2RightColumn;
